var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconSearch = function SvgIconSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#9FA8B9",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M13.4 13.5c1.3-1.1 2-2.7 2-4.5 0-3.3-2.7-6-6.2-6S3 5.7 3 9s2.8 6 6.2 6a6.3 6.3 0 0 0 4.2-1.5Zm0 0 3.1 3"
  })));
};
export default SvgIconSearch;